
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import formatPhoneNumber from "@/app/infrastructures/misc/common-library/FormatPhoneNumber";
import { DetailClientManagement } from "@/domain/entities/ClientManagement";

class Props {
  detailData = prop<DetailClientManagement>({
    required: true,
    default: new DetailClientManagement()
  });
}

@Options({
  components: {
    Title
  }
})
export default class DetailParentClient extends Vue.with(Props) {
  get idClient() {
    return String(this.detailData.id);
  }
  formatPhoneNumber(value: string) {
    return formatPhoneNumber(value);
  }
}
